module.exports = __webpack_public_path__ + "assets/Deals-2.4d1130e9.svg";